export const PATTERNS = {
  EMAIL_PATTERN: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  PASSWORD_PATTERN: /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$/,
  NAME_PATTERN: /[\S]+/,
  VIN_PATTERN: /[A-HJ-NPR-Z0-9]{17}/,

  // This regular expression checks telephone number without country code (+1)
  PHONE_PATTERN: /^\d{10,13}$/,
  PHONE_PATTERN_10_NUMBERS: /^\d{10}$/,
};
